var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expired-badge-wrapper"},[_c('el-badge',{staticClass:"expired-badge",attrs:{"value":"提醒","title":"点击可查看详情"},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.openDialog.apply(null, arguments)}}},[_c('span',{staticClass:"expired-date-info"},[_vm._v(_vm._s(_vm.displayEndTime))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }